import { useTranslation } from "react-i18next";
import textos from "./textos/QueHacer.jsx";

// Pàgina "que-hacer" de l'Hotel Camprodon. Els textos propis de cada idioma
// són a textos/QueHacer.jsx; els genèrics, amb t() (Traducciones/lang).
// El comportament (sliders, galeria, formularis...) és a ContenidoHtml.
const QueHacer = ({ lang }) => {

    const { t } = useTranslation();
    const tx = textos[lang] ?? textos.es;

    return (
        <>
            <section className="c-hero c-hero--large">
                <div className="c-hero--container" style={{maxHeight: "100vh"}}>
                    <div>
                        <div className="position-relative">
                            <picture>
                                <img src="/images/web/hotelcamprodon/p/entorn__1920x1036__rio-puente-rocas-pueblo-hotel-camprodon-1678981801.jpeg" alt={tx.heroImageAlt} className="image-cover image-full c-hero__image" width="100%" height="100%" />
                            </picture>
                            <div className="c-hero__content position-relative">
                                <span className="c-hero__small-title text-uppercase">{tx.heroSmallTitle}</span>
                                <h1 className="c-hero__title">{tx.heroTitle}</h1>
                                <span className="line max-line-height">
                                    <svg aria-hidden="true" focusable="false" className="c-icon ico-mouse">
                                        <use href="/images/web/hotelcamprodon/icons-sprite.svg#sprite-icon-ico-mouse-scrolldown"></use>
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div id="c-sticky-widget-notifier"></div>
            <section className="c-sticky-widgets d-inline-flex position-relative">
                <div className="c-sticky-widgets--button c-sticky-widgets--booking d-flex-center"><a href={tx.stickyWidgetsButtonHref} className="text-uppercase text-center d-flex-center">{t("Reserva hotel")}</a></div>
                <div className="c-sticky-widgets--button c-sticky-widgets--restaurant d-flex-center"><a href={tx.stickyWidgetsButtonHref2} target="_blank" className="text-uppercase text-center d-flex-center" rel="noopener noreferrer">{t("Reserva restaurante")}</a></div>
            </section>
            <section className="position-relative bg-gray ">
                <div className="c-benefits-slider d-flex-center o-container">
                    <span className="c-benefits-slider__small-title text-uppercase">{t("Ventajas de reservar en el web oficial")}</span>
                    <ul id="draggable-slider" className="c-slider list-style-none m-0 p-0">
                        <li className="c-benefits-slider__benefit">
                            <picture>
                                <img src="/images/web/hotelcamprodon/p/avantatges-icones__millor-preu-1678981853.svg" className="c-icon" width="22" height="24" loading="lazy" decoding="async" alt={t("Mejor precio garantizado")} />
                            </picture>
                            <div>
                                <span>{t("Mejor precio garantizado")}</span>
                            </div>
                        </li>
                        <li className="c-benefits-slider__benefit">
                            <picture>
                                <img src="/images/web/hotelcamprodon/p/avantatges-icones__reserva-segura-1678981853.svg" className="c-icon" width="22" height="24" loading="lazy" decoding="async" alt={t("Reserva segura")} />
                            </picture>
                            <div>
                                <span>{t("Reserva segura")}</span>
                            </div>
                        </li>
                        <li className="c-benefits-slider__benefit">
                            <picture>
                                <img src="/images/web/hotelcamprodon/p/avantatges-icones__confirmacio-1678981853.svg" className="c-icon" width="22" height="24" loading="lazy" decoding="async" alt={t("Confirmación inmediata")} />
                            </picture>
                            <div>
                                <span>{t("Confirmación inmediata")}</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </section>
            <section className="c-presentation o-container text-center ">
                <div className="c-presentation__small-title text-uppercase">{tx.presentationSmallTitle}</div>
                <h2 className="c-presentation__title">{tx.presentationTitle}</h2>
                <div className="c-presentation__content">
                    <p>{tx.presentationContent}</p>
                </div>
            </section>
            <section className="o-container">
                <div className="c-cards-list">
                    <article className="c-card c-card--with-price">
                        <div className="c-card__header">
                            <picture>
                                <img src="/images/web/hotelcamprodon/p/entorn__626x389__grupo-amigos-montana-hotel-camprodon-1678194634.jpeg" className="image-cover" width="100%" height="100%" loading="lazy" decoding="async" alt={t("Camprodón")} />
                            </picture>
                        </div>
                        <div className="c-card__body">
                            <div className="c-card__content">{tx.cardContent}</div>
                            <div className="c-card__footer"><a href={tx.linkHref} className="c-link">{t("Descubrir")}</a></div>
                        </div>
                    </article>
                    <article className="c-card c-card--with-price">
                        <div className="c-card__header">
                            <picture>
                                <img src="/images/web/hotelcamprodon/p/entorn__626x389__familia-bicicletas-actividades-hotel-camprodon-1678269739.jpeg" className="image-cover" width="100%" height="100%" loading="lazy" decoding="async" alt={t("Actividades en Camprodón")} />
                            </picture>
                        </div>
                        <div className="c-card__body">
                            <div className="c-card__content">{tx.cardContent2}</div>
                            <div className="c-card__footer"><a href={tx.linkHref2} className="c-link">{t("Descubrir")}</a></div>
                        </div>
                    </article>
                </div>
            </section>
        </>
    );
};

export default QueHacer;
